import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Snackbar, Slide, styled } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { hideToast } from "store/slices/toastSlice";

const StyledAlert = styled(MuiAlert)(() => ({
  border: "0px",
}));

const Alert = React.forwardRef((props, ref) => <StyledAlert elevation={6} variant="filled" {...props} ref={ref} />);

const slideTransition = (props) => {
  return <Slide {...props} direction="left" />;
};

function Toast() {
  const dispatch = useDispatch();
  const { show, message, severity } = useSelector((state) => state.toast);

  const handleSnackBarClose = () => {
    dispatch(hideToast());
  };

  return (
    <Snackbar
      TransitionComponent={slideTransition}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={show}
      onClose={handleSnackBarClose}
      autoHideDuration={3000}
    >
      <Alert icon={false} severity={severity} onClose={handleSnackBarClose}>{message}</Alert>
    </Snackbar>
  );
}

export default Toast;
